import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import "../../scss/card.css"
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';

const SectionViewPdfBook = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        sectionSyllabusStructureMasterId: '',
        sectionLessonMasterId: '',
        sectionTopicMasterId: '',
        sectionSubTopicId: '',
        sectionSubTopicName: '',
        details: '',
        instituteSubjectMasterId: ''
    }

    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [subjectList, setSubjectList] = useState([])
    const [syType, setSyType] = useState("")
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (subtopicData.sectionSyllabusStructureMasterId !== '' && subtopicData.instituteSubjectMasterId !== '') {
            let apiUrl = '';

            const apiUrls = {
                B: `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&` +
                    (subtopicData.sectionSyllabusStructureMasterId ? `sectionSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&` : '') +
                    (subtopicData.instituteSubjectMasterId ? `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&` : '') +
                    (subtopicData.sectionLessonMasterId ? `sectionLessonMasterId=${subtopicData.sectionLessonMasterId}&` : '') +
                    (subtopicData.sectionTopicMasterId ? `sectionTopicMasterId=${subtopicData.sectionTopicMasterId}&` : '') +
                    (subtopicData.sectionSubTopicId ? `sectionSubTopicId=${subtopicData.sectionSubTopicId}&` : ''),
                I: `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&` +
                    (subtopicData.sectionSyllabusStructureMasterId ? `instituteSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&` : '') +
                    (subtopicData.instituteSubjectMasterId ? `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&` : '') +
                    (subtopicData.sectionLessonMasterId ? `instituteLessonMasterId=${subtopicData.sectionLessonMasterId}&` : '') +
                    (subtopicData.sectionTopicMasterId ? `instituteTopicMasterId=${subtopicData.sectionTopicMasterId}&` : '') +
                    (subtopicData.sectionSubTopicId ? `instituteSubTopicId=${subtopicData.sectionSubTopicId}&` : ''),
                A: `/get-sub-topic-master-list?` +
                    (subtopicData.sectionSyllabusStructureMasterId ? `syllabusStructureId=${subtopicData.sectionSyllabusStructureMasterId}&` : '') +
                    (subtopicData.instituteSubjectMasterId ? `subjectMasterId=${subtopicData.instituteSubjectMasterId}&` : '') +
                    (subtopicData.sectionLessonMasterId ? `lessonId=${subtopicData.sectionLessonMasterId}&` : '') +
                    (subtopicData.sectionTopicMasterId ? `topicId=${subtopicData.sectionTopicMasterId}&` : '') +
                    (subtopicData.sectionSubTopicId ? `subTopicId=${subtopicData.sectionSubTopicId}&` : '')
            };

            // Retrieve the API URL based on the syType
            apiUrl = apiUrls[syType];

            // Remove trailing '&' if it exists
            apiUrl = apiUrl.replace(/&$/, '');

            // Use the appropriate Axios instance
            const axiosInstances = {
                B: authorizedAxiosSection,
                I: authorizedAxiosInstitute,
                A: authorizedAxios
            };

            const axiosInstance = axiosInstances[syType];

            axiosInstance && axiosInstance.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result);
                })
                .catch(error => {
                    setSubtopicList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [subtopicData]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                setSyllabusList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        const { name, value } = e.target; // Destructure name and value from e.target
        const id = value.slice(0, -1); // Get the ID by removing the last character
        const type = value.slice(-1); // Get the type (last character)

        // Reset states
        setLessonList([]);
        setTopicList([]);
        setSubtopicData([]);
        setSubtopicList([]);
        setSubjectList([]);

        // Set syllabus type and update subtopic data state
        setSyType(type); // Use the last character to determine type
        setSubtopicData((prevData) => ({
            ...prevData,
            [name]: id, // Use destructured name for updating the ID
            sectionLessonMasterId: '',
            sectionTopicMasterId: '',
            sectionSubTopicId: '',
            instituteSubjectMasterId: ''
        }));

        // Define axios instances and API URLs based on type
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios,
            B: authorizedAxiosSection
        };

        const apiUrls = {
            I: `/get-institute-syllabus-structure-Wise-institute-subjects?id=${id}`,
            A: `/syllabus-structure-wise-subjects?id=${id}`,
            B: `/get-section-syllabus-structure-Wise-section-subjects?id=${id}`
        };

        // Fetch subjects based on type
        const axiosInstance = axiosInstances[type];
        const apiUrl = apiUrls[type];

        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubjectList(response.data.result); // Set subject list from API response
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };

    const handleSubjectChange = (e) => {
        const { name, value } = e.target; // Destructure name and value from e.target

        // Update subtopic data state
        setSubtopicData((prevData) => ({
            ...prevData,
            [name]: value, // Use destructured name and value
            sectionLessonMasterId: '',
            sectionTopicMasterId: '',
            sectionSubTopicId: ''
        }));

        // Define axios instances and API URLs based on syType
        const axiosInstances = {
            B: authorizedAxiosSection,
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrls = {
            B: `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${value}`,
            I: `/get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${value}`,
            A: `/subject-wise-lesson?syllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&subjectMasterId=${value}`
        };

        // Get correct axios instance and API URL based on syType
        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];

        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result); // Set lesson list from API response
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };

    const handleLessonChange = (e) => {
        const { name, value } = e.target; // Destructure name and value from e.target

        // Update subtopic data state
        setSubtopicData((prevData) => ({
            ...prevData,
            [name]: value, // Use destructured name and value
            sectionTopicMasterId: '',
            sectionSubTopicId: ''
        }));

        // Define axios instances and API URLs based on syType
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios,
            B: authorizedAxiosSection
        };

        const apiUrls = {
            I: `/get-institute-lesson-wise-institute-sub-topic?id=${value}`,
            A: `/lesson-wise-topic?id=${value}`,
            B: `/get-section-lesson-wise-section-sub-topic?id=${value}`
        };

        // Get correct axios instance and API URL based on syType
        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];

        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result); // Set topic list from API response
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };

    const handleTopicChange = (e) => {
        const { name, value } = e.target; // Destructure name and value from e.target
    
        // Update subtopic data state
        setSubtopicData((prevData) => ({
            ...prevData,
            [name]: value, // Use destructured name and value
            sectionSubTopicId: ''
        }));
    
        // Define axios instances and API URLs based on syType
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios,
            B: authorizedAxiosSection
        };
    
        const apiUrls = {
            I: `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&instituteLessonMasterId=${subtopicData.sectionLessonMasterId}&instituteTopicMasterId=${value}`,
            A: `/get-sub-topic-master-list?syllabusStructureId=${subtopicData.sectionSyllabusStructureMasterId}&subjectMasterId=${subtopicData.instituteSubjectMasterId}&lessonId=${subtopicData.sectionLessonMasterId}&topicId=${value}`,
            B: `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&sectionLessonMasterId=${subtopicData.sectionLessonMasterId}&sectionTopicMasterId=${value}`
        };
    
        // Get correct axios instance and API URL based on syType
        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];
    
        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubTopicViewtopicList(response.data.result); // Set subtopic list from API response
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setSubTopicViewtopicList([]); // Reset list in case of error
                });
        }
    };    

    const handleNext = () => {
        if (currentIndex < subtopicList.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    useEffect(() => {
        setCurrentIndex(0)
    }, [subtopicData])

    const navigate = useNavigate()

    const handleNavigate = (route) => {
        navigate(route);
    };

    const generatePDF = () => {
        let apiUrl = window.location.origin;
        if (subtopicData.sectionSyllabusStructureMasterId) {
            apiUrl += `/print?syType=${syType}&SyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&`;
        }
        if (subtopicData.instituteSubjectMasterId) {
            apiUrl += `SubjectMasterId=${subtopicData.instituteSubjectMasterId}&`
        }
        if (instituteMasterId) {
            apiUrl += `instituteMasterId=${instituteMasterId}&`;
        }
        if (sectionMasterId) {
            apiUrl += `sectionMasterId=${sectionMasterId}&`;
        }
        if (subtopicData.sectionLessonMasterId) {
            apiUrl += `LessonMasterId=${subtopicData.sectionLessonMasterId}&`;
        }
        if (subtopicData.sectionTopicMasterId) {
            apiUrl += `TopicMasterId=${subtopicData.sectionTopicMasterId}&`;
        }
        if (subtopicData.sectionSubTopicId) {
            apiUrl += `SubTopicId=${subtopicData.sectionSubTopicId}&`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        window.open(apiUrl, "_blank");
    };

    return (
        <>
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>View Content Book</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i> View Content Book</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionSyllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.sectionSyllabusStructureMasterId + syType}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option style={{ color: syllabus.type == "I" ? "blue" : syllabus.type == "B" ? "red" : '' }} value={syllabus.id + syllabus.type}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required className="form-select" aria-label="Default select example" name="instituteSubjectMasterId" onChange={handleSubjectChange} value={subtopicData?.instituteSubjectMasterId} >
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {subjectList?.map((syllabus) => {
                                                            const subjectDetail = syType === "A" ? syllabus?.subjectMasterDetails : syllabus?.instituteSubjectMasterDetails;
                                                            return (
                                                                <option key={subjectDetail?.id} value={subjectDetail?.id}>
                                                                    {subjectDetail?.subjectName}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="col-form-label">Select Lesson :</label>
                                                    <select required className="form-select" aria-label="Default select example" name="sectionLessonMasterId" onChange={handleLessonChange} value={subtopicData.sectionLessonMasterId} >
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {lessonList?.map((lesson) => {
                                                            const lessonName = syType === "B" ? lesson.sectionLessonName : syType === "I" ? lesson.instituteLessonName : syType === "A" ? lesson.lessonName : '';
                                                            return (
                                                                <option key={lesson.id} value={lesson.id}>
                                                                    {lessonName}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="col-form-label">Select Topic :</label>
                                                    <select required className="form-select" aria-label="Default select example" name="sectionTopicMasterId" onChange={handleTopicChange} value={subtopicData.sectionTopicMasterId} >
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {topicList?.map((topic) => {
                                                            const topicName = syType === "B" ? topic.sectionTopicName : syType === "I" ? topic.instituteTopicName : syType === "A" ? topic.topicName : '';
                                                            return (
                                                                <option key={topic.id} value={topic.id}>
                                                                    {topicName}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="col-form-label">Select Sub Topic :</label>
                                                    <select required className="form-select" aria-label="Default select example" name="sectionSubTopicId" onChange={handleInputChange} value={subtopicData.sectionSubTopicId} >
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {subTopicViewtopicList?.map((topic) => {
                                                            const subTopicName = syType === "B" ? topic.sectionSubTopicName : syType === "I" ? topic.instituteSubTopicName : syType === "A" ? topic.subTopicName : '';
                                                            return (
                                                                <option key={topic.id} value={topic.id}>
                                                                    {subTopicName}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => { setSubtopicData(initialFormState); setSubtopicList([]); setSyType('') }}>Reset</button>
                                            </div>

                                            {subtopicData.sectionSyllabusStructureMasterId.length !== 0 && subtopicData.instituteSubjectMasterId && subtopicList !== undefined && (
                                                <div className="content_book_wraper">
                                                    {subtopicList.length !== 0 && (
                                                        <h4 className="text-blue" onClick={() => generatePDF(subtopicList)}>
                                                            <b>
                                                                <span className="fa fa-file-o"></span>
                                                                <button className='print-btn btn btn-info'>
                                                                    Print <i className="fa fa-print"></i>
                                                                </button>
                                                            </b>
                                                        </h4>
                                                    )}
                                                    <div className="content_book_wrap">
                                                        <div className="row">
                                                            <div className="book">
                                                                <div className='lesson_area'>
                                                                    <div className='lesson_no'>
                                                                        <div className='info'>
                                                                            <span className='capt'>Class:</span>
                                                                            <span className='value'>
                                                                                {syType === "B"
                                                                                    ? subtopicList[currentIndex]?.sectionSyllabusStructureMasterDetails?.instituteGradeMasterDetails?.gradeName
                                                                                    : syType === "I"
                                                                                        ? subtopicList[currentIndex]?.instituteSyllabusStructureMasterDetails?.instituteGradeMasterDetails?.gradeName
                                                                                        : subtopicList[currentIndex]?.subTopicMasterSyllabusStructureMasterDetails?.gradeMasterDetails?.gradeName
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                        <div className='info'>
                                                                            <span className='capt'>Subject:</span>
                                                                            <span className='value'>
                                                                                {syType === "B"
                                                                                    ? subtopicList[currentIndex]?.instituteSubjectMasterDetails?.subjectName
                                                                                    : syType === "I"
                                                                                        ? subtopicList[currentIndex]?.instituteSubjectMasterDetails?.subjectName
                                                                                        : subtopicList[currentIndex]?.subjectMasterDetails?.subjectName
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='chapter_name'>
                                                                        <div className='info'>
                                                                            <span className='capt'>Chapter Name:</span>
                                                                            <span className='value'>
                                                                                {syType === "B"
                                                                                    ? subtopicList[currentIndex]?.sectionLessonMasterDetails?.sectionLessonName
                                                                                    : syType === "I"
                                                                                        ? subtopicList[currentIndex]?.instituteLessonMasterDetails?.instituteLessonName
                                                                                        : subtopicList[currentIndex]?.subTopicMasterLessonMasterDetails?.lessonName
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="page">
                                                                    {subtopicList[currentIndex]?.details ? (
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${subtopicList[currentIndex].details}</div>`
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <p style={{
                                                                            textAlign: "center",
                                                                            fontSize: "1rem",
                                                                            color: "#333",
                                                                            fontStyle: "italic",
                                                                            margin: "20px 0",
                                                                            padding: "10px",
                                                                            backgroundColor: "#f0f0f0",
                                                                            borderRadius: "4px",
                                                                            border: "1px solid #ccc",
                                                                        }}>
                                                                            No content available.
                                                                        </p>
                                                                    )}
                                                                </div>

                                                                <div className='nav_btn_progress'>
                                                                    <button className="btn btn-outline-danger view_icon" type="button" style={{ marginRight: '0' }} disabled={currentIndex === 0} onClick={handlePrev}>
                                                                        <i className="fa fa-chevron-left"></i>
                                                                    </button>

                                                                    <div className="progress_bar_block">
                                                                        <span className='read_progress' style={{ width: `${((currentIndex + 1) / subtopicList.length) * 100}%` }}></span>
                                                                    </div>
                                                                    <button className="btn btn-outline-danger view_icon" type="button" style={{ marginRight: '0' }} disabled={currentIndex === subtopicList.length - 1} onClick={handleNext}>
                                                                        <i className="fa fa-chevron-right"></i>
                                                                    </button>
                                                                </div>

                                                                <div className='page_no_area'>
                                                                    <div className='page_no'>
                                                                        <span>{currentIndex + 1} of {subtopicList.length}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionViewPdfBook;